import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {  numberFormat } from '../Extras';
import { addItemshoppingCartAction } from '../../redux/actions';
import { IoIosAdd, IoMdRemove } from 'react-icons/io';
import Form from 'react-bootstrap/Form';
import Footer from '../LayOut/Footer';
import Header from '../LayOut/Header';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './../Extras/Product.css';
import { Link, Redirect } from 'react-router-dom';


const formStyle = {
	padding: 0,
	paddingLeft: 10,
	paddingTop: 5,
	paddingBottom: 5,
	marginTop: '10px'
};

const itemsNumberStyle = {
	boxShadow: '2px 3px 5px #E7E7E7',
	borderRadius: 10,
}


const addButtonStyle = (shopColor) => ({
	backgroundColor: shopColor,
	color: 'white',
	fontSize: 15,
	alignItems: 'center',
	width: '100%',
	borderRadius: 10,
})

class ProductComponent extends React.Component {
	state = {
		quantity: 1,
		categoryValue: '',
		price: 1000,
		firstPrice: 1000,
		price2: '',
		showMessage: '',
		loaded: false,
	};


	componentDidMount = () => {
		
		if(this.props.location.state !== undefined){
			this.setState({	
				quantity: 1,
				categoryValue: '',
				price: this.props.location.state.information.data_.price || 1000,
				firstPrice: this.props.location.state.information.data_.price || 1000,
				price2: this.props.location.state.information.data_.price2,
				showMessage: '',
				loaded: true
			})
		
	}	}


	handleChange = (e) => {
		const subCategories = this.props.location.state.information.data_.subCategories
		let  price  = this.state.firstPrice
		let price2; 

		for(const i in subCategories){
				if(subCategories[i].name === e.target.value && subCategories[i].price !== ""){
					price = subCategories[i].price
					price2 = subCategories[i].price2
				}
		}
		console.log(price, price2, "Jjajajaj")
		this.setState({
			categoryValue: e.target.value,
			price,
			price2,
		});
	};
	
	changeQuantity = (quantity_) => {
		let { quantity } = this.state;
		if (quantity < 99 && quantity_ === 1) {
			quantity = quantity + quantity_;
		} else if (quantity > 0 && quantity_ === -1) {
			quantity = quantity + quantity_;
		}

		this.setState({
			quantity
    });
    
	};

	addItem = (item_) => {

		console.log(item_)

		item_.price = this.state.price
		item_.price2 = this.state.price2

		
		if(item_.toggleEspecification === false || item_.toggleEspecification === ""){
			item_.toggleEspecification = false
		}
		else{
				item_.toggleEspecification = true
		}

		console.log("item", item_.price, item_.price2)
		if (this.state.quantity > 0) {
			if (item_.subCategories !== [] && this.state.categoryValue !== '') {
				this.props.addItemShoppingCart(item_, this.state.quantity, this.state.categoryValue);

				this.setState({
					showMessage: 'Producto Agregado'
				});
				
				setTimeout(
					() =>
						this.setState({
							showMessage: ''
						}),
					3000
        );
        
			} else if(item_.toggleEspecification === false) {
				this.props.addItemShoppingCart(item_, this.state.quantity, null);

				this.setState({
					showMessage: 'Producto Agregado'
				});
				setTimeout(
					() =>
						this.setState({
							showMessage: ''
						}),
					3000
				);
			}
		}
	};

	displayPriceCategory = () => {
		const subCategories  = this.props.location.state.information.data_.subCategories || [];
		let toggleEspecification = this.props.location.state.information.data_.toggleEspecification
		if(toggleEspecification === false || toggleEspecification === ""){
			toggleEspecification = false
		}
		else{
				toggleEspecification = true
		}
		return (
			<div className="row align-items-center mb-1" style={{ height: '50px' }}>
				<div className="col-md-6 col-6" style={{ borderRadius: '5%', fontSize: 14, fontWeight: 'bold' }}>
					{toggleEspecification === true && subCategories.length > 0 ? (
						<Form>
							<Form.Group controlId="exampleForm.ControlSelect1">
								<Form.Control
									onChange={(e) => this.handleChange(e)}
									defaultValue={'Selecciona'}
                  as="select"
                  style={formStyle}
								>
									<option value="Selecciona" disabled>
										{'Selecciona'}
									</option>

									{subCategories.map((option, index) => {
										return (
											<Fragment key={index}>
												
												{option.stock === true ? (
													<option disabled style={{ backgroundColor: 'lightGray'}}> {option.name} </option>
												) : (
													<option> {option.name} </option>
												)}
											</Fragment>
										);
									})}
								</Form.Control>
							</Form.Group>
						</Form>
					) : (
						''
					)}
				</div>
			</div>
		);
	};

	displayAddItem = () => {
		let item_ = {	
			id: this.props.location.state.information.name,
			name: this.props.location.state.information.data_.name || '',
			price: this.props.location.state.information.data_.price || 1000,
			price2: this.props.location.state.information.data_.price2,
			subCategories: this.props.location.state.information.data_.subCategories || [],
			toggleEspecification: this.props.location.state.information.data_.toggleEspecification,
			images: this.props.location.state.information.data_.images,
			category: this.props.location.state.category
		};
	
		return (
			<Fragment>
				<div className="row align-items-center mt-1">
					{this.props.location.state.information.data_.stock === 0 ? (
						'Producto Agotado'
					) : (
						<Fragment>
							<div className="col-12 ml-3" style={{fontSize: 12}}>
								{this.state.showMessage}
							</div>
							
							<div
								className="itemsNumberStyle col-5 row ml-4 justify-content-center align-items-center"
								style={itemsNumberStyle}
							>
    							<div
    								className="col-2 col-md-1 offset-md-1 p-0"
    								onClick={() => this.changeQuantity(-1)}
    							>
                      <IoMdRemove 
                        className="iconStyle"
                        size={20} 
                        color="#747e90"
                      />
    							</div>

    							<div className="col-3 col-md-1 d-flex justify-content-center mx-2"
									  style={{color:'#747e90', fontSize:'20px'}}
								  >
									  {this.state.quantity}
    							</div>

    							<div className="col-2 col-md-1 p-0" onClick={() => this.changeQuantity(1)}>
                      <IoIosAdd 
                        className="iconStyle"
                        size={20} 
                        color="#747e90"
                      />
    							</div>	
							</div>

							<div className="col-6 offset-md-1 ml-2">
								<button
									className="btn"
									style={addButtonStyle(this.props.shopColor)}
									onClick={() => this.addItem(item_)}
								>
									Agregar
								</button>
							</div>
						</Fragment>
					)}
				</div>
			</Fragment>
		);
	};

	render() {
		
		if (this.state.loaded === false){
			if(this.props.location.state === undefined){
				let url = this.props.location.pathname.split('/')[1];
				return <Redirect to={{ pathname: `/${url}` }} />;
				
			}
		}


		const { information } = this.props.location.state;
		let url;

		if (information.data_.images[0] !== undefined) {
			const array_ = information.data_.images[0].url.split('?alt');
			url = `${array_[0]}?alt${array_[1]}`;
		} else {
			url = '';
		}	

		console.log("informacion", information, this.state.price, this.state.price2, this.state.categoryValue)
		return (
			<Fragment>
				<Header arrowLeft={true}/>
	
					<div className="container col-md-3 offset-md-4 mt-2" style={{ fontWeight: 'bold', fontSize: 23, color: '#2a2a2a'}}>
						{information.data_.name}
					</div>

          <div className="d-flex col-md-4 offset-md-4 p-0 mt-3 justify-content-center">
            {url === '' ? <img src={require('../../images/simple2.png')} className="ImageStyle" alt="SimpleQr"  /> : 
            
            <Carousel style={{maxWidth: '100%'}} centerSlidePercentage={0} showThumbs={false} showStatus={false}>
              {information.data_.images.map((image) => {
                return(
                  <img className="ImageStyle" src={image.url} alt="SimpleQr" />
                )
              })}  
            </Carousel> 
            }
          </div>
					
					<div className="container col-md-3 offset-md-4"
						style={{overflowY: 'scroll', marginBottom:'100px'}}
					>						

						<div 
							className="row ml-2 mt-2"
							style={{ fontWeight: 'bold', fontSize: 23, color: '#2a2a2a'}}
						>

							{information.data_.toggleEspecification === true ? 

								//SI TIENE SUBCATEGORIAS
								this.state.categoryValue !== '' ?
								
									<Fragment>
										<Fragment>
										{this.state.price !== this.state.price2 && this.state.price2 !== '' && this.state.price2 !== undefined ? 
												<Fragment>
													<div className="row col-12 col-md-12">
														${numberFormat(this.state.price2)}
													</div>
													<div className="row col-12 col-md-12 ml-1">
														<del style={{fontSize: 12}}> ${numberFormat(this.state.price)} </del>
													</div>
												</Fragment>
												:
												`$ ${numberFormat(this.state.price)}` 
										}
										</Fragment>		
									</Fragment> : ''
								
								:
								
								//SI NO TIENE SUBCATEGORIAS!
								<Fragment>
									{information.data_.stock === true && information.data_.toggleEspecification !== true ? (
									'AGOTADO'
										) : (
											<Fragment>
												{information.data_.price !== information.data_.price2 && information.data_.price2 !== '' && information.data_.price2 !== undefined ? 
														<Fragment>
															<div className="row col-12 col-md-12">
																${numberFormat(information.data_.price2)}
															</div>
															<div className="row col-12 col-md-12 ml-1">
																<del style={{fontSize: 12}}> ${numberFormat(information.data_.price)} </del>
															</div>
														</Fragment>
														:
														`$ ${numberFormat(information.data_.price)}` 
												}
											</Fragment>
										)}
								</Fragment>
								
							}
						
						</div>	

						{information.data_.toggleEspecification === true ?  this.displayPriceCategory() : ''}
						
						{this.props.toggleWhatsAppMethod === true || this.props.toggleDelivery === true || this.props.toggleWithdrawal === true ?
							<Fragment>
								{information.data_.stock === true && information.data_.toggleEspecification !== true ? '' : this.displayAddItem() }
							</Fragment>
						: ''}

						<div 
							className="row ml-2 mb-2 mt-3" 
							style={{ fontWeight: 'bold', fontSize: 17, color: '#2a2a2a'}}
						>
							Sobre el Producto
							
						</div>

						<textarea
							disabled
							className="commentaryStyle p-2"
						>
							{information.data_.commentary}
						</textarea>

				</div>
				<Footer/>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	shopColor: state.shopColor,
	toggleWithdrawal: state.toggleWithdrawal,
	toggleDelivery: state.toggleDelivery,
	toggleWhatsAppMethod: state.toggleWhatsAppMethod
});

const mapDispatchToProps = (dispatch) => ({
	addItemShoppingCart(product, quantity, category) {
		dispatch(addItemshoppingCartAction(product, quantity, category));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductComponent);
